module.exports = __webpack_public_path__ + "img/processed-agent-hub.5d495d2b.svg";